import React from 'react';
import { Route, Switch } from 'react-router-dom';

import BinconsolidationDashboard from '../../../Maintenance/Binconsolidation/BinconsolidationDashboard/index';
import BinconsolidationConfirmation from '../../../Maintenance/Binconsolidation/BinconsolidationConfirmation/index';
import ReportsForm from '../../../Maintenance/sapvswms/index';
import AssignUserForm from '../../../CycleCount/AssignUser/index';
import CycleCountConfirmationForm from '../../../CycleCount/CycleCountConfirmation/index';
import StockMovementForm from '../../../Maintenance/StockMovement/index';
import stockMovementNew from '../../../Maintenance/stockMovementNew/index';
import stockMovementToGood from '../../../Maintenance/stockMovementToGood/index';
import stockMovementApproval from '../../../Maintenance/stockMovementApproval/index';


import StockTransfer from '../../../Maintenance/StockTransfer/index';
import StockTransferUploader from '../../../Maintenance/StockTransferUploader/index';
import createNew from '../../../CycleCount/createNew/index';
import CycleCountApproval from '../../../CycleCount/cycleCountApproval/index';
import CycleCountApprovalNew from '../../../CycleCount/cycleCountApprovalNew/index';





export default () => (
  <Switch>
    <Route path="/maintenance/BinconsolidationDashboard" component={BinconsolidationDashboard} />
	<Route path="/maintenance/BinconsolidationConfirmation" component={BinconsolidationConfirmation} />
	<Route path="/maintenance/Customervswmsinvetory" component={ReportsForm} />
	<Route path="/maintenance/cycleCount/assignUser" component={AssignUserForm} />
	<Route path="/maintenance/cycleCount/create_new" component={createNew} />
	<Route path="/maintenance/cycleCount/cycleCountApprovalNew" component={CycleCountApprovalNew} />
	<Route path="/maintenance/cycleCount/cycleCountApproval" component={CycleCountApproval} />

	<Route path="/maintenance/cycleCountConfirmation" component={CycleCountConfirmationForm} />
    <Route path="/Maintenance/stockMovement" component={StockMovementForm} />
    <Route path="/Maintenance/stockMovementNew" component={stockMovementNew} />
	<Route path="/Maintenance/stockMovement_dmgtogood" component={stockMovementToGood} />
    <Route path="/Maintenance/stockMovementApproval" component={stockMovementApproval} />


	<Route path="/Maintenance/stock_transfer" component={StockTransfer} />
	<Route path="/Maintenance/stock_transfer_uploader" component={StockTransferUploader} />
  </Switch>
);
